import React from 'react';
import iconAdvisor from '~/assets/images/advise-man.svg';
import iconReviews from '~/assets/images/advise-reviews.svg';
import iconLocation from '~/assets/images/advise_location.svg';
import Container from '~/components/ui/Container';
import Panel from '~/components/ui/Panel';
import StatsCard from '~/components/ui/StatsCard';
import type { CompanyStats } from '~/types/Company';

type CompanyIntroProps = {
  companyName: string;
  companyDescription?: string;
  companyStats: CompanyStats;
};

const CompanyIntro: React.FC<CompanyIntroProps> = ({
  companyName,
  companyDescription,
  companyStats: { reviewsCount, officesCount, employeesCount },
}) => {
  return (
    <Container className="relative z-10 -mt-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-6">
        <Panel className="lg:col-span-8">
          <h2 className="panel-title--primary">Over {companyName}</h2>
          {companyDescription}
        </Panel>
        <div className="lg:col-span-4">
          <Panel>
            <div className="grid grid-cols-3 gap-4 lg:gap-10 lg:grid-cols-1">
              {reviewsCount != null && (
                <StatsCard
                  containerClassName="lg:flex-row"
                  contentClassName="lg:text-left"
                  imageLink={iconReviews as string}
                  stat={reviewsCount?.toLocaleString('nl') as string}
                  text="Reviews"
                  alt="Reviews"
                />
              )}
              <StatsCard
                containerClassName="lg:flex-row"
                contentClassName="lg:text-left"
                imageLink={iconLocation as string}
                stat={officesCount?.toLocaleString('nl') as string}
                text="Aangesloten kantoren"
                alt="Aangesloten kantoren"
              />
              <StatsCard
                containerClassName="lg:flex-row"
                contentClassName="lg:text-left"
                imageLink={iconAdvisor as string}
                stat={employeesCount?.toLocaleString('nl') as string}
                text="Adviseurs"
                alt="Adviseurs"
              />
            </div>
          </Panel>
        </div>
      </div>
    </Container>
  );
};

export default CompanyIntro;
